var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.6464 15.0564L7.35348 10.7635C7.15822 10.5682 7.15822 10.2516 7.35348 10.0564L8.05686 9.35299C8.25193 9.15792 8.56814 9.1577 8.76348 9.3525L11.9999 12.5799L15.2364 9.3525C15.4317 9.1577 15.7479 9.15792 15.943 9.35299L16.6464 10.0564C16.8416 10.2516 16.8416 10.5682 16.6464 10.7635L12.3535 15.0564C12.1582 15.2516 11.8416 15.2516 11.6464 15.0564Z",
  fill: "#CCE3F0"
})));
export default SvgArrowDown;